(() => {
  const root = document.documentElement;

  root.classList.add('is-entering');

  requestAnimationFrame(() => {
    root.classList.remove('is-entering');
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const url = new URL(link.href, window.location.href);

    const shouldSkip =
      url.origin !== window.location.origin ||
      link.target === '_blank' ||
      link.hasAttribute('download') ||
      link.hash ||
      link.closest('form') ||
      url.pathname.includes('/cart') ||
      url.pathname.includes('/checkout') ||
      url.pathname.includes('/account') ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey;

    if (shouldSkip) return;

    event.preventDefault();

    root.classList.add('is-leaving');

    setTimeout(() => {
      window.location.href = link.href;
    }, 180);
  });

  window.addEventListener('pageshow', () => {
    root.classList.remove('is-leaving');
  });
})();